import { useState } from 'react';
import html2canvas from 'html2canvas';
import classNames from 'classnames';
import { IS_DEV } from '../../utils/envSettings';
import './HelpWidget.scss';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from '../Button/Button';

export default function HelpWidget() {
  const [showModal, setShowModal] = useState(false);
  const [captureUrl, setCaptureUrl] = useState(null);

  const onHide = () => {
    setShowModal(false);
  }

  const onCapture = async () => {
    setShowModal(false);

    setTimeout(async () => {
      const canvas = await html2canvas(document.body);
      console.log('canvas:', canvas);
  
      setCaptureUrl(canvas.toDataURL());
      setShowModal(true);
    }, 300);
  }

  return (
    <>
      <button className={classNames('__help-widget', { '__help-widget-dev': IS_DEV })} onClick={() => setShowModal(true)}>?</button>
      <Screenshot show={false} />
      <Modal className='__modal __help-modal' show={showModal} onHide={onHide} backdrop='static' centered size='lg'>
        <Modal.Header closeButton onHide={onHide}><h2>Support</h2></Modal.Header>
        <Modal.Body>
          <Form.Label>Issue Type</Form.Label>
          <Dropdown className='my-2'>
            <Dropdown.Toggle>Select an issue...</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>User</Dropdown.Item>
              <Dropdown.Item>Leads</Dropdown.Item>
              <Dropdown.Item>Lead Import</Dropdown.Item>
              <Dropdown.Item>Bug Report</Dropdown.Item>
              <Dropdown.Item>Billing</Dropdown.Item>
              <Dropdown.Item>Other</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button variant='link' onClick={onCapture}>Attach Screenshot</Button>

          { captureUrl && <img src={captureUrl} style={{ maxWidth: '50%', border: '2px solid gray' }} alt='screenshot' /> }
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' className='cancel' onClick={onHide}>Close</Button>
          <Button type='submit' className='confirm'>Send</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function Screenshot({ show, onCapture }) {
  return show && (
    <div className='__screenshot'>
      <div className='screenshot-container' />
    </div>
  );
}
